import { render, staticRenderFns } from "./veggiesbonanza.vue?vue&type=template&id=1cef8424&scoped=true"
import script from "./veggiesbonanza.vue?vue&type=script&lang=js"
export * from "./veggiesbonanza.vue?vue&type=script&lang=js"
import style0 from "./veggiesbonanza.vue?vue&type=style&index=0&id=1cef8424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef8424",
  null
  
)

export default component.exports